const breakpoints = require("../assets/js/breakpoints.min.js");

export default window.breakpoints = breakpoints;
